import React from 'react';
import classNames from 'classnames';
import propTypes from 'prop-types';

import { getMessage } from 'util/locale';

import BaseTrigger from './BaseTrigger';

import { trackAction } from 'util/analytics';

const baseString = 'vra-duplicate-trigger';
const DuplicateTrigger = ({
  className,
  disabled,
  scriptId,
  onClickDuplicateTrigger
}) => {
  const classString = classNames({
    [`${baseString}`]: true,
    [`${className}`]: !!className
  });

  return (
    <BaseTrigger
      className={classString}
      content={getMessage('button-text__duplicate')}
      dataTestId={baseString}
      disabled={disabled}
      handler={() => { 
        trackAction(`Clicked on Make a Copy, Rx: ${scriptId}`);
        onClickDuplicateTrigger(scriptId);
      }}
    />
  );
};
DuplicateTrigger.propTypes = {
  className: propTypes.string,
  disabled: propTypes.bool,
  onClickDuplicateTrigger: propTypes.func.isRequired,
  scriptId: propTypes.string.isRequired
};
export default DuplicateTrigger;
